<v-app><v-main :style="{'background': backgroundData,}"><LoadingOverlay :is_loading="is_loading"></LoadingOverlay><RouterView></RouterView></v-main></v-app>